import type { ThemeConfig } from 'antd';

export type ThemeKey =
  | 'neutral'
  | 'gold'
  | 'emerald'
  | 'sapphire'
  | 'rose_gold'
  | 'obsidian'
  | 'ivory';

export interface AppThemePreset {
  key: ThemeKey;
  name: string;
  theme: ThemeConfig;
  previewColor: string;
}

// 主题预设：
// - neutral：默认黑色主色，体现中立、公正
// - gold：奢华金
// - emerald：祖母绿
// - sapphire：蓝宝石蓝
export const THEME_PRESETS: Record<ThemeKey, AppThemePreset> = {
  neutral: {
    key: 'neutral',
    name: 'Neutral / 中立黑',
    previewColor: '#000000',
    theme: {
      token: {
        colorPrimary: '#000000',
        colorLink: '#000000',
      },
    },
  },
  gold: {
    key: 'gold',
    name: 'Gold / 奢华金',
    previewColor: '#D4AF37',
    theme: {
      token: {
        colorPrimary: '#D4AF37',
        colorLink: '#D4AF37',
      },
    },
  },
  emerald: {
    key: 'emerald',
    name: 'Emerald / 祖母绿',
    previewColor: '#2ECC71',
    theme: {
      token: {
        colorPrimary: '#2ECC71',
        colorLink: '#27AE60',
      },
    },
  },
  sapphire: {
    key: 'sapphire',
    name: 'Sapphire / 蓝宝石蓝',
    previewColor: '#1E6EFF',
    theme: {
      token: {
        colorPrimary: '#1E6EFF',
        colorLink: '#1E6EFF',
      },
    },
  },
  rose_gold: {
    key: 'rose_gold',
    name: 'Rose Gold / 玫瑰金',
    previewColor: '#B76E79',
    theme: {
      token: {
        colorPrimary: '#B76E79',
        colorLink: '#B76E79',
      },
    },
  },
  obsidian: {
    key: 'obsidian',
    name: 'Obsidian / 曜石黑',
    previewColor: '#0B0B0B',
    theme: {
      token: {
        colorPrimary: '#0B0B0B',
        colorLink: '#0B0B0B',
      },
    },
  },
  ivory: {
    key: 'ivory',
    name: 'Ivory / 象牙白',
    previewColor: '#EEE5D5',
    theme: {
      token: {
        colorPrimary: '#C9B79C',
        colorLink: '#C9B79C',
      },
    },
  },
};

export const DEFAULT_THEME_KEY: ThemeKey = 'neutral';
